<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:class="headerClasses"
  >
    <div
      class="container-fluid d-flex align-items-right justify-content-between"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left col p-0 align-self-center"
        ref="kt_header_menu_wrapper"
      >
        <div class="row align-items-center">
          <div class="col-auto">
            <h6
              class="mb-0 font-weight-bolder align-items-center"
              v-blur-sensitive
              v-html="currentUserPersonalInfo.cliente"
            ></h6>
            <p
              class="mb-0"
              v-if="currentUserPersonalInfo.conta"
              v-b-tooltip.html="
                isPresentationMode
                  ? 'Código da conta oculto no modo apresentação'
                  : currentUserPersonalInfo.conta_id
              "
            >
              <span class="font-weight-bolder">Conta:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.conta }}
              </span>
            </p>
            <p class="mb-0" v-if="currentUserPersonalInfo.emailCliente">
              <span class="font-weight-bolder">Email:</span>
              <span v-blur-sensitive>
                {{ currentUserPersonalInfo.emailCliente }}
              </span>
            </p>
          </div>

          <div
            class="col-auto"
            v-if="
              (checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1
            "
          >
            <div class="d-flex">
              <button
                @click="trocarUsuarioOuConta"
                class="btn btn-wellon-branco btn-sm"
              >
                <i class="fas fa-arrow-right-arrow-left"></i>
                Trocar Conta
              </button>
              <button
                v-if="hasPermission('modo-apresentacao')"
                @click="togglePresentation"
                class="btn btn-wellon-branco btn-sm ml-3"
                :class="{ active: isPresentationMode }"
                title="Modo Apresentação"
              >
                <i
                  :class="
                    isPresentationMode ? 'fas fa-eye-slash' : 'fas fa-eye'
                  "
                ></i>
                {{ isPresentationMode ? "Desativar" : "Ativar" }} Apresentação
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Header Menu -->

      <KTTopbar></KTTopbar>
    </div>

    <b-modal
      ref="mdlTrocarUsuarioOuConta"
      @hidden="limpar"
      ignore-enforce-focus-selector=".swal2-container"
      v-if="(checkSuperAdmin || isAccountAdmin) && contasParaTroca.length > 1"
      hide-footer
      size="lg"
      scrollable
      content-class="trocar-conta-modal-content"
      header-class="trocar-conta-modal-header border-0"
      body-class="trocar-conta-modal-body"
    >
      <template #modal-header="{ close }">
        <div class="trocar-conta-modal-header__conteudo">
          <h5 class="trocar-conta-modal-header__titulo">Trocar Conta</h5>
          <modal-wizard v-if="checkSuperAdmin"></modal-wizard>
          <button
            type="button"
            class="close"
            aria-label="Fechar"
            @click="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <div>
        <button
          v-if="checkSuperAdmin && hasAccount"
          type="button"
          class="trocar-conta-admin-card"
          @click="trocarParaSuperAdmin"
        >
          <span class="trocar-conta-admin-card__icone">
            <i class="fas fa-star"></i>
          </span>
          <span class="trocar-conta-admin-card__textos">
            <span class="trocar-conta-admin-card__titulo">
              Trocar para Administrador do Sistema
            </span>
            <span class="trocar-conta-admin-card__subtitulo">
              Acesse o painel com visão completa da plataforma.
            </span>
          </span>
        </button>

        <div class="trocar-conta-busca-wrap mb-3">
          <b-form-input
            ref="inputBusca"
            v-model="filtroContas"
            placeholder="Buscar por nome, sigla, código ou documento"
            @input="debounce"
            @keyup.enter="changeSelected"
            @keyup.up="handleKeyUpDown"
            @keyup.down="handleKeyUpDown"
            :autofocus="true"
            class="trocar-conta-busca"
          ></b-form-input>
          <button
            v-if="filtroContas.length > 0"
            type="button"
            class="trocar-conta-busca__limpar"
            title="Limpar busca"
            @click="limparBusca"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="trocar-conta-chips">
          <button
            v-for="chip in chipsFiltro"
            :key="chip.valor"
            type="button"
            class="trocar-conta-chip"
            :class="{ 'trocar-conta-chip--ativo': filtroStatus === chip.valor }"
            @click="filtroStatus = chip.valor"
          >
            {{ chip.texto }}
          </button>
        </div>

        <div v-if="!listaPronta" class="trocar-conta-lista-carregando">
          <v-progress-circular
            indeterminate
            size="32"
            color="#462181"
            width="2"
          >
            <v-progress-circular
              indeterminate
              size="24"
              color="#ff7f00"
              width="2"
              rotate="180"
            ></v-progress-circular>
          </v-progress-circular>
        </div>

        <div v-else ref="lista" class="trocar-conta-lista">
          <template v-for="item in itensLista">
            <div
              v-if="item.tipo === 'cabecalho'"
              :key="item.chave"
              class="trocar-conta-secao-titulo"
            >
              <span>
                <i
                  class="fas fa-circle trocar-conta-dot"
                  :class="`trocar-conta-dot--${item.corDot}`"
                ></i>
                {{ item.texto }}
              </span>
              <span class="trocar-conta-secao-contador">
                {{ item.contador }} conta{{ item.contador === 1 ? "" : "s" }}
              </span>
            </div>

            <div v-else :key="item.chave" class="trocar-conta-card">
              <div class="trocar-conta-card__principal">
                <button
                  type="button"
                  class="trocar-conta-card__info linha-navegavel"
                  :class="{
                    'trocar-conta-card__info--atual': ehContaAtual(
                      item.grupo.principal
                    )
                  }"
                  :data-conta-id="item.grupo.principal.id"
                  @click="trocarConta(item.grupo.principal.id)"
                  @keydown="handleKeyUpDown"
                >
                  <span class="trocar-conta-avatar" v-blur-sensitive>
                    {{ avatarTexto(item.grupo.principal) }}
                  </span>

                  <span class="trocar-conta-card__textos">
                    <span class="trocar-conta-card__linha1">
                      <span class="trocar-conta-card__nome" v-blur-sensitive>
                        {{ nomeExibicao(item.grupo.principal) }}
                      </span>
                      <i
                        v-if="!item.grupo.principal.contaPrincipalId"
                        class="fas fa-certificate trocar-conta-icone-principal"
                        v-b-tooltip.noninteractive.hover
                        title="Conta principal"
                      ></i>
                      <i
                        class="fas fa-circle trocar-conta-dot"
                        :class="`trocar-conta-dot--${
                          statusInfo(item.grupo.principal.status).classe
                        }`"
                        v-b-tooltip.noninteractive.hover
                        :title="statusInfo(item.grupo.principal.status).texto"
                      ></i>
                    </span>
                    <span class="trocar-conta-meta" v-blur-sensitive>
                      <span
                        class="trocar-conta-tag trocar-conta-tag--copiavel"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o login"
                        @click.stop="
                          copiar(item.grupo.principal.login, 'Login')
                        "
                      >
                        @{{ item.grupo.principal.login }}
                      </span>
                      <span
                        class="trocar-conta-tag trocar-conta-tag--copiavel"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o código"
                        @click.stop="copiar(item.grupo.principal.id, 'Código')"
                      >
                        #{{ item.grupo.principal.id }}
                      </span>
                      <span
                        v-if="documentoNumero(item.grupo.principal)"
                        class="trocar-conta-tag trocar-conta-tag--copiavel"
                        v-b-tooltip.noninteractive.hover
                        title="Clique para copiar o CPF/CNPJ"
                        @click.stop="copiarDocumento(item.grupo.principal)"
                      >
                        ⌘ {{ documentoNumero(item.grupo.principal) }}
                      </span>
                      <a
                        v-if="item.grupo.principal.ctiIntegracaoId"
                        :href="linkConexa(item.grupo.principal)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="trocar-conta-tag trocar-conta-tag--link"
                        v-b-tooltip.noninteractive.hover
                        title="Abrir contratos no Conexa"
                        @click.stop
                      >
                        ↗ Conexa
                      </a>
                      <span
                        v-if="item.grupo.subcontasVisiveis.length > 0"
                        class="trocar-conta-tag"
                      >
                        {{ item.grupo.subcontasVisiveis.length }} subconta{{
                          item.grupo.subcontasVisiveis.length === 1 ? "" : "s"
                        }}
                      </span>
                    </span>

                    <span
                      v-if="saldos[item.grupo.principal.id]"
                      class="trocar-conta-saldo"
                    >
                      <span class="trocar-conta-saldo__barra">
                        <span
                          class="trocar-conta-saldo__uso"
                          :style="{
                            width:
                              saldos[item.grupo.principal.id].percentual + '%'
                          }"
                        ></span>
                      </span>
                      <span class="trocar-conta-saldo__texto">
                        Saldo restante:
                        {{
                          saldos[item.grupo.principal.id].saldo.toLocaleString(
                            "pt-BR"
                          )
                        }}
                        de
                        {{
                          saldos[
                            item.grupo.principal.id
                          ].credito.toLocaleString("pt-BR")
                        }}
                        <i
                          v-if="riscoFaltarSaldo(item.grupo.principal.id)"
                          class="fas fa-exclamation-triangle trocar-conta-saldo__alerta"
                          v-b-tooltip.noninteractive.hover
                          title="No ritmo atual de consumo, o saldo deve terminar antes do fim do ciclo mensal."
                        ></i>
                      </span>
                    </span>
                  </span>
                </button>

                <div class="trocar-conta-card__acoes">
                  <button
                    v-if="podeConfigurarConta(item.grupo.principal)"
                    type="button"
                    class="trocar-conta-acao-btn"
                    :disabled="
                      saldosCarregando.includes(item.grupo.principal.id)
                    "
                    v-b-tooltip.noninteractive.hover
                    title="Calcular saldo"
                    @click.stop="carregarSaldo(item.grupo.principal.id)"
                  >
                    <i
                      :class="
                        saldosCarregando.includes(item.grupo.principal.id)
                          ? 'fas fa-spinner fa-spin'
                          : 'fas fa-coins'
                      "
                    ></i>
                  </button>

                  <button
                    type="button"
                    class="trocar-conta-acao-btn"
                    v-b-popover.click.blur.html="
                      popoverInfo(item.grupo.principal)
                    "
                    v-b-tooltip.noninteractive.hover
                    title="Detalhes"
                    @click.stop
                  >
                    <i class="fas fa-info-circle"></i>
                  </button>

                  <b-dropdown
                    v-if="podeConfigurarConta(item.grupo.principal)"
                    no-caret
                    dropleft
                    variant="link"
                    toggle-class="trocar-conta-acao-btn p-0"
                    menu-class="trocar-conta-menu"
                  >
                    <template #button-content>
                      <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                      @click.prevent="acaoConfiguracao(item.grupo.principal)"
                      ><i class="fas fa-cog mr-2"></i
                      >Configuração</b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="podeConfigurarConta(item.grupo.principal)"
                      @click.prevent="acaoUsuarios(item.grupo.principal)"
                      ><i class="fas fa-users mr-2"></i
                      >Usuários</b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="!item.grupo.principal.contaPrincipalId"
                      @click.prevent="acaoCadastrar(item.grupo.principal)"
                      ><i class="fas fa-plus mr-2"></i>Cadastrar
                      Conta</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click.prevent="acaoEnviarManual(item.grupo.principal)"
                      ><i class="fa fa-upload mr-2"></i>Enviar
                      Manual</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click.prevent="acaoAlterarSenha(item.grupo.principal)"
                      ><i class="fas fa-key mr-2"></i>Alterar
                      Senha</b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="checkSuperAdmin"
                      @click.prevent="alterarStatusConta(item.grupo.principal)"
                      ><i
                        :class="
                          item.grupo.principal.status === 'A'
                            ? 'fas fa-lock mr-2'
                            : 'fas fa-unlock mr-2'
                        "
                      ></i
                      >{{
                        item.grupo.principal.status === "A"
                          ? "Bloquear"
                          : "Desbloquear"
                      }}</b-dropdown-item
                    >
                  </b-dropdown>

                  <button
                    v-if="
                      !ocultarSubcontas &&
                      item.grupo.subcontasVisiveis.length > 0
                    "
                    type="button"
                    class="trocar-conta-card__toggle"
                    @click="alternarExpandirPrincipal(item.grupo.principal.id)"
                    :title="
                      grupoEstaExpandido(item.grupo)
                        ? 'Recolher subcontas'
                        : 'Expandir subcontas'
                    "
                  >
                    <i
                      :class="
                        grupoEstaExpandido(item.grupo)
                          ? 'fas fa-chevron-up'
                          : 'fas fa-chevron-down'
                      "
                    ></i>
                  </button>
                </div>
              </div>

              <div
                v-if="
                  !ocultarSubcontas &&
                  grupoEstaExpandido(item.grupo) &&
                  item.grupo.subcontasVisiveis.length > 0
                "
                class="trocar-conta-card__subcontas"
              >
                <div class="trocar-conta-card__subcontas-cabecalho">
                  <span
                    >Subcontas ({{ item.grupo.subcontasVisiveis.length }})</span
                  >
                </div>

                <div
                  v-for="sub in subcontasParaExibir(item.grupo)"
                  :key="sub.id"
                  class="trocar-conta-subconta"
                >
                  <button
                    type="button"
                    class="trocar-conta-subconta__info linha-navegavel"
                    :class="{
                      'trocar-conta-card__info--atual': ehContaAtual(sub)
                    }"
                    :data-conta-id="sub.id"
                    @click="trocarConta(sub.id)"
                    @keydown="handleKeyUpDown"
                  >
                    <span class="trocar-conta-subconta__textos">
                      <span
                        class="trocar-conta-subconta__nome"
                        v-blur-sensitive
                      >
                        {{ nomeExibicao(sub) }}
                      </span>
                      <span class="trocar-conta-meta" v-blur-sensitive>
                        <span
                          class="trocar-conta-tag trocar-conta-tag--copiavel"
                          v-b-tooltip.noninteractive.hover
                          title="Clique para copiar o login"
                          @click.stop="copiar(sub.login, 'Login')"
                          >@{{ sub.login }}</span
                        >
                        <span
                          class="trocar-conta-tag trocar-conta-tag--copiavel"
                          v-b-tooltip.noninteractive.hover
                          title="Clique para copiar o código"
                          @click.stop="copiar(sub.id, 'Código')"
                          >#{{ sub.id }}</span
                        >
                      </span>
                    </span>
                    <i
                      class="fas fa-circle trocar-conta-dot"
                      :class="`trocar-conta-dot--${
                        statusInfo(sub.status).classe
                      }`"
                      v-b-tooltip.noninteractive.hover
                      :title="statusInfo(sub.status).texto"
                    ></i>
                  </button>

                  <div class="trocar-conta-subconta__acoes">
                    <button
                      type="button"
                      class="trocar-conta-acao-btn trocar-conta-acao-btn--sm"
                      v-b-popover.click.blur.html="popoverInfo(sub)"
                      v-b-tooltip.noninteractive.hover
                      title="Detalhes"
                      @click.stop
                    >
                      <i class="fas fa-info-circle"></i>
                    </button>

                    <b-dropdown
                      v-if="podeConfigurarConta(sub)"
                      no-caret
                      dropleft
                      variant="link"
                      toggle-class="trocar-conta-acao-btn trocar-conta-acao-btn--sm p-0"
                      menu-class="trocar-conta-menu"
                    >
                      <template #button-content>
                        <i class="fas fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.prevent="acaoConfiguracao(sub)"
                        ><i class="fas fa-cog mr-2"></i
                        >Configuração</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="podeConfigurarConta(sub)"
                        @click.prevent="acaoUsuarios(sub)"
                        ><i class="fas fa-users mr-2"></i
                        >Usuários</b-dropdown-item
                      >
                      <b-dropdown-item @click.prevent="acaoEnviarManual(sub)"
                        ><i class="fa fa-upload mr-2"></i>Enviar
                        Manual</b-dropdown-item
                      >
                      <b-dropdown-item @click.prevent="acaoAlterarSenha(sub)"
                        ><i class="fas fa-key mr-2"></i>Alterar
                        Senha</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="checkSuperAdmin"
                        @click.prevent="alterarStatusConta(sub)"
                        ><i
                          :class="
                            sub.status === 'A'
                              ? 'fas fa-lock mr-2'
                              : 'fas fa-unlock mr-2'
                          "
                        ></i
                        >{{
                          sub.status === "A" ? "Bloquear" : "Desbloquear"
                        }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>

                <button
                  v-if="
                    !termoBusca.trim() &&
                    item.grupo.subcontasVisiveis.length >
                      limiteSubcontasPadrao &&
                    !subcontasExpandidas.includes(item.grupo.principal.id)
                  "
                  type="button"
                  class="trocar-conta-ver-todas"
                  @click="expandirTodasSubcontas(item.grupo.principal.id)"
                >
                  Ver todas as
                  {{ item.grupo.subcontasVisiveis.length }} subcontas
                </button>
              </div>
            </div>
          </template>

          <p v-if="itensLista.length === 0" class="text-muted text-center my-4">
            Nenhuma conta encontrada.
          </p>
        </div>
      </div>
    </b-modal>

    <modal-configuracao
      v-if="contaConfig"
      ref="modalConfiguracao"
      :conta="contaConfig"
      tipoBotao="nenhum"
      :exibirAbasConta="exibirAbasConfig"
    ></modal-configuracao>

    <modal-adicionar-conta
      v-if="contaAcao"
      ref="modalCadastrar"
      :contaPrincipal="contaAcao"
      tipoBotao="nenhum"
      @conta:cadastrada="contaCadastrada"
    ></modal-adicionar-conta>

    <modal-enviar-manual
      v-if="contaAcao"
      ref="modalEnviarManual"
      :conta="contaAcao"
      tipoBotao="nenhum"
    ></modal-enviar-manual>

    <modal-alterar-senha
      v-if="contaAcao"
      ref="modalAlterarSenha"
      :id="contaAcao.id"
      url="conta/alterarSenha"
      titulo="Alterar Senha da Conta"
      :exigirSenhaAtual="false"
      tipoBotao="nenhum"
    ></modal-alterar-senha>

    <modal-usuarios
      v-if="contaAcao"
      ref="modalUsuarios"
      :conta="contaAcao"
      tipoBotao="nenhum"
    ></modal-usuarios>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import ApiService from "../../../core/services/api.service";
import Utils from "@/core/utils/Utils";
import Swal from "sweetalert2";
import moment from "moment";
import ModalConfiguracao from "@/view/pages/painel/conta/ModalConfiguracao.vue";
import ModalAdicionarConta from "@/view/pages/painel/conta/ModalAdicionarConta.vue";
import ModalEnviarManual from "@/view/pages/painel/conta/ModalEnviarManual.vue";
import ModalAlterarSenha from "@/view/components/ModalAlterarSenha.vue";
import ModalUsuarios from "@/view/pages/painel/conta/ModalUsuarios.vue";
import ModalWizard from "@/view/pages/painel/conta/wizard/ModalWizard.vue";

const STATUS_INFO = {
  A: { texto: "Ativa", classe: "ativa" },
  I: { texto: "Inativa", classe: "inativa" },
  B: { texto: "Bloqueada", classe: "bloqueada" },
  S: { texto: "Suspensa", classe: "suspensa" }
};

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    "modal-configuracao": ModalConfiguracao,
    "modal-adicionar-conta": ModalAdicionarConta,
    "modal-enviar-manual": ModalEnviarManual,
    "modal-alterar-senha": ModalAlterarSenha,
    "modal-usuarios": ModalUsuarios,
    "modal-wizard": ModalWizard
  },
  data() {
    return {
      contas: [],
      idContaSelecionada: null,
      filtroContas: "",
      termoBusca: "",
      filtroStatus: "ativas",
      debounceTimeout: null,
      limiteSubcontasPadrao: 3,
      principaisExpandidos: [],
      subcontasExpandidas: [],
      contaConfig: null,
      exibirAbasConfig: false,
      contaAcao: null,
      saldos: {},
      saldosCarregando: [],
      chipsFiltro: [
        { valor: "todas", texto: "Todas" },
        { valor: "ativas", texto: "Ativas" },
        { valor: "inativas", texto: "Inativas" },
        { valor: "principais", texto: "Principais" },
        { valor: "recentes", texto: "Recentes" }
      ],
      diasContaRecente: 120,
      // O bootstrap-vue desmonta o conteúdo do modal ao fechar (não fica em
      // cache) — sem isso, toda abertura recalcula e renderiza a lista
      // inteira (potencialmente centenas de cards) de uma vez, travando a UI
      // por alguns segundos sem feedback nenhum. Mostrando o shell (busca +
      // chips) de imediato e a lista pesada um instante depois, o modal
      // sempre abre na hora, só a lista aparece com um respiro.
      listaPronta: false
    };
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
  },
  computed: {
    ...mapGetters([
      "getClasses",
      "currentUserPersonalInfo",
      "hasAccount",
      "isAccountAdmin",
      "contasParaTroca",
      "checkSuperAdmin",
      "isPresentationMode",
      "hasPermission"
    ]),

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    ocultarSubcontas() {
      return this.filtroStatus === "principais";
    },

    // Agrupa a lista plana de contas em contas principais + suas subcontas,
    // já aplicando o termo de busca (nome, login, sigla, id ou documento).
    // Uma subconta cujo pai não esteja na lista (ex.: usuário vinculado só à
    // subconta) é tratada como um grupo "principal" próprio, sem cair fora da tela.
    gruposContas() {
      const contasPorId = new Map(
        this.contas.map((conta) => [conta.id, conta])
      );
      const termo = this.termoBusca.trim().toLowerCase();
      const termoDigitos = termo.replace(/\D/g, "");

      const correspondeTermo = (conta) => {
        if (!termo) {
          return true;
        }

        const documentoLimpo = Utils.limparDocumento(
          conta.documento
        ).toLowerCase();

        return (
          this.nomeExibicao(conta).toLowerCase().includes(termo) ||
          (conta.login || "").toLowerCase().includes(termo) ||
          (conta.sigla || "").toLowerCase().includes(termo) ||
          String(conta.id).includes(termo) ||
          (termoDigitos.length > 0 && documentoLimpo.includes(termoDigitos))
        );
      };

      const subcontasPorPrincipal = new Map();
      const principais = [];

      this.contas.forEach((conta) => {
        const temPrincipalNaLista =
          conta.contaPrincipalId && contasPorId.has(conta.contaPrincipalId);

        if (temPrincipalNaLista) {
          if (!subcontasPorPrincipal.has(conta.contaPrincipalId)) {
            subcontasPorPrincipal.set(conta.contaPrincipalId, []);
          }
          subcontasPorPrincipal.get(conta.contaPrincipalId).push(conta);
        } else {
          principais.push(conta);
        }
      });

      return principais
        .map((principal) => {
          const subcontas = (subcontasPorPrincipal.get(principal.id) || [])
            .slice()
            .sort((a, b) =>
              this.nomeExibicao(a).localeCompare(this.nomeExibicao(b))
            );

          const principalCorresponde = correspondeTermo(principal);

          // Se a própria conta principal casa com a busca, mantemos todas as
          // subcontas visíveis (ex.: buscar "Meddi" não pode ocultar a
          // subconta "Multimagem"). Só filtramos subcontas quando o match veio
          // exclusivamente de uma subconta.
          const subcontasVisiveis =
            termo && !principalCorresponde
              ? subcontas.filter(correspondeTermo)
              : subcontas;

          return {
            principal,
            subcontasVisiveis,
            corresponde: principalCorresponde || subcontasVisiveis.length > 0
          };
        })
        .filter((grupo) => grupo.corresponde)
        .filter(
          (grupo) =>
            this.filtroStatus !== "recentes" ||
            this.contaRecente(grupo.principal)
        )
        .sort((a, b) => {
          const pesoA = a.principal.status === "A" ? 0 : 1;
          const pesoB = b.principal.status === "A" ? 0 : 1;

          if (pesoA !== pesoB) {
            return pesoA - pesoB;
          }

          return this.nomeExibicao(a.principal).localeCompare(
            this.nomeExibicao(b.principal)
          );
        });
    },

    gruposContasAtivas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status === "A"
      );
    },

    gruposContasInativas() {
      return this.gruposContas.filter(
        (grupo) => grupo.principal.status !== "A"
      );
    },

    exibirSecaoAtivas() {
      return this.filtroStatus !== "inativas";
    },

    exibirSecaoInativas() {
      return this.filtroStatus !== "ativas";
    },

    // Lista única (cabeçalhos de seção + cards) na ordem final de exibição,
    // para não duplicar o markup do card entre as seções ativas/inativas.
    itensLista() {
      const itens = [];
      const ativas = this.gruposContasAtivas;
      const inativas = this.gruposContasInativas;

      if (this.exibirSecaoAtivas && ativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-ativas",
          texto: "Contas ativas",
          contador: ativas.length,
          corDot: "ativa"
        });
        ativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      if (this.exibirSecaoInativas && inativas.length > 0) {
        itens.push({
          tipo: "cabecalho",
          chave: "cabecalho-inativas",
          texto: "Contas inativas",
          contador: inativas.length,
          corDot: "inativa"
        });
        inativas.forEach((grupo) =>
          itens.push({
            tipo: "grupo",
            chave: `grupo-${grupo.principal.id}`,
            grupo
          })
        );
      }

      return itens;
    }
  },

  methods: {
    ...mapActions(["togglePresentationMode"]),

    togglePresentation() {
      const title = `Você deseja ${
        this.isPresentationMode ? "desativar" : "ativar"
      } o modo de apresentação?`;
      const text = this.isPresentationMode
        ? "Essa ação irá revelar informações sensíveis na tela."
        : "Essa ação irá ocultar informações sensíveis na tela para apresentações.";
      Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          this.togglePresentationMode();
        }
      });
    },

    trocarUsuarioOuConta() {
      // contasParaTroca já inclui a conta atual (marcada e não clicável); assim
      // a conta atual não some e as subcontas não ficam órfãs.
      this.contas = [...this.contasParaTroca];
      this.listaPronta = false;
      this.$refs["mdlTrocarUsuarioOuConta"].show();

      // Deixa o shell (busca + chips) pintar antes de montar a lista pesada —
      // ver comentário de listaPronta em data().
      setTimeout(() => {
        this.listaPronta = true;
      }, 0);
    },

    ehContaAtual(conta) {
      return String(conta.id) === String(this.currentUserPersonalInfo.conta_id);
    },

    // Contas principais criadas há poucos dias tendem a estar em período de
    // implantação — usado pelo chip "Recentes".
    contaRecente(conta) {
      if (!conta.dataCadastro) {
        return false;
      }

      const dataCadastro = moment(conta.dataCadastro);

      if (!dataCadastro.isValid()) {
        return false;
      }

      return moment().diff(dataCadastro, "days") <= this.diasContaRecente;
    },

    nomeExibicao(conta) {
      return conta.nome || conta.cliNome || conta.login || "";
    },

    avatarTexto(conta) {
      if (conta.sigla && conta.sigla.trim()) {
        return conta.sigla.trim().toUpperCase().slice(0, 3);
      }

      const nome = this.nomeExibicao(conta).trim();
      if (!nome) {
        return "?";
      }

      const partes = nome.split(/\s+/);
      if (partes.length === 1) {
        return partes[0].slice(0, 2).toUpperCase();
      }

      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },

    documentoExibicao(conta) {
      const limpo = Utils.limparDocumento(conta.documento);

      if (!limpo) {
        return "";
      }

      if (limpo.length === 11) {
        return `CPF: ${Utils.formatarDocumento(limpo)}`;
      }

      if (limpo.length === 14) {
        return `CNPJ: ${Utils.formatarDocumento(limpo)}`;
      }

      return `Documento: ${conta.documento}`;
    },

    // Só o documento formatado (sem rótulo), para o badge compacto. O próprio
    // formato distingue CPF (11) de CNPJ (14).
    documentoNumero(conta) {
      const limpo = Utils.limparDocumento(conta.documento);

      if (!limpo) {
        return "";
      }

      return Utils.formatarDocumento(limpo) || conta.documento;
    },

    // Copia um valor (login, id ou documento) para a área de transferência,
    // com feedback via toast — facilita o dia a dia do suporte.
    copiar(valor, rotulo) {
      if (!valor) {
        return;
      }

      navigator.clipboard.writeText(String(valor)).then(() => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: `${rotulo} copiado`,
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true
        });
      });
    },

    copiarDocumento(conta) {
      this.copiar(Utils.limparDocumento(conta.documento), "CPF/CNPJ");
    },

    linkConexa(conta) {
      return `https://w3.conexa.app/index.php?r=vendaRecorrente/gerenciarContratos&idCliente=${conta.ctiIntegracaoId}`;
    },

    // Conteúdo HTML do popover ⓘ com os dados operacionais que saíram do card
    // (cadastro, último envio, limite). Cada linha só entra se preenchida,
    // datas em formato Brasil.
    popoverInfo(conta) {
      const linhas = [];

      if (conta.dataCadastro) {
        const data = moment(conta.dataCadastro);
        if (data.isValid()) {
          linhas.push(["Cadastro", data.format("DD/MM/YYYY")]);
        }
      }

      if (conta.dataUltimoEnvio) {
        const data = moment(conta.dataUltimoEnvio);
        if (data.isValid()) {
          linhas.push(["Último envio", data.format("DD/MM/YYYY HH:mm")]);
        }
      }

      if (conta.limiteCredito !== null && conta.limiteCredito !== undefined) {
        const limite = Number(conta.limiteCredito);
        if (!Number.isNaN(limite)) {
          linhas.push(["Limite", limite.toLocaleString("pt-BR")]);
        }
      }

      if (!linhas.length) {
        return "Sem informações adicionais.";
      }

      const corpo = linhas
        .map(
          ([rotulo, valor]) =>
            `<div class="trocar-conta-pop__linha"><span>${rotulo}</span><strong>${valor}</strong></div>`
        )
        .join("");

      return { html: true, content: corpo, title: "Detalhes da conta" };
    },

    // Calcula o saldo/consumo desta conta sob demanda (consulta pesada não é
    // feita para todas as contas ao abrir o modal). Resultado exibido no card.
    async carregarSaldo(idConta) {
      if (this.saldosCarregando.includes(idConta)) {
        return;
      }

      this.saldosCarregando.push(idConta);

      try {
        const { data } = await ApiService.get(`conta/saldo/${idConta}`);
        const dados = data.data;
        const credito = Number(dados.credito) || 0;
        const saldo = Number(dados.saldo) || 0;
        const consumo = Number(dados.consumo) || 0;
        const percentual =
          credito > 0
            ? Math.min(100, Math.round((consumo / credito) * 100))
            : 0;

        this.$set(this.saldos, idConta, {
          credito,
          saldo,
          consumo,
          percentual
        });
      } finally {
        this.saldosCarregando = this.saldosCarregando.filter(
          (id) => id !== idConta
        );
      }
    },

    // Compara o ritmo de consumo com o ritmo do calendário: se já foi
    // consumida uma fração do saldo maior que a fração do mês já
    // transcorrida (ex.: dia 13 de um mês de 30 dias = 43% do mês, mas mais
    // de 50% do saldo já consumido), a tendência é faltar antes do fim do
    // ciclo mensal.
    riscoFaltarSaldo(idConta) {
      const dados = this.saldos[idConta];

      if (!dados) {
        return false;
      }

      const hoje = moment();
      const fracaoMes = hoje.date() / hoje.daysInMonth();
      const fracaoConsumida = dados.percentual / 100;

      return fracaoConsumida > fracaoMes;
    },

    acaoConfiguracao(conta) {
      this.abrirConfiguracao(conta);
    },

    acaoUsuarios(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalUsuarios.abrir());
    },

    acaoCadastrar(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalCadastrar.abrir());
    },

    acaoEnviarManual(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalEnviarManual.abrir());
    },

    acaoAlterarSenha(conta) {
      this.contaAcao = conta;
      this.$nextTick(() => this.$refs.modalAlterarSenha.abrir());
    },

    contaCadastrada() {
      Swal.fire({
        icon: "success",
        title: "Subconta cadastrada!",
        text: "Ela aparecerá na lista após atualizar a sessão.",
        timer: 2500,
        showConfirmButton: false
      });
    },

    // Bloquear/Desbloquear reusando o mesmo endpoint da tela Contas
    // (GET conta/status/{bloquear|desbloquear}/{id}).
    alterarStatusConta(conta) {
      const bloquear = conta.status === "A";
      const rota = bloquear ? "bloquear" : "desbloquear";

      Swal.fire({
        title: `Deseja realmente ${rota} a conta "${this.nomeExibicao(
          conta
        )}"?`,
        showCancelButton: true,
        confirmButtonText: bloquear ? "Bloquear" : "Desbloquear",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: bloquear ? "btn btn-danger" : "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        ApiService.get(`conta/status/${rota}/${conta.id}`)
          .then((response) => {
            const atualizada = response.data.data;
            conta.status =
              atualizada && atualizada.status
                ? atualizada.status
                : bloquear
                ? "B"
                : "A";

            Swal.fire({
              icon: "success",
              title: `Conta ${bloquear ? "bloqueada" : "desbloqueada"}!`,
              timer: 2000,
              showConfirmButton: false
            });
          })
          .catch(() => {});
      });
    },

    statusInfo(status) {
      return STATUS_INFO[status] || STATUS_INFO.B;
    },

    subcontasParaExibir(grupo) {
      if (this.termoBusca.trim()) {
        return grupo.subcontasVisiveis;
      }

      if (this.subcontasExpandidas.includes(grupo.principal.id)) {
        return grupo.subcontasVisiveis;
      }

      return grupo.subcontasVisiveis.slice(0, this.limiteSubcontasPadrao);
    },

    expandirTodasSubcontas(idPrincipal) {
      if (!this.subcontasExpandidas.includes(idPrincipal)) {
        this.subcontasExpandidas.push(idPrincipal);
      }
    },

    alternarExpandirPrincipal(idPrincipal) {
      const indice = this.principaisExpandidos.indexOf(idPrincipal);
      if (indice === -1) {
        this.principaisExpandidos.push(idPrincipal);
      } else {
        this.principaisExpandidos.splice(indice, 1);
      }
    },

    grupoEstaExpandido(grupo) {
      if (this.termoBusca.trim() && grupo.subcontasVisiveis.length > 0) {
        return true;
      }

      return this.principaisExpandidos.includes(grupo.principal.id);
    },

    debounce(filtro) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.termoBusca = filtro;
        this.removeSelected();
      }, 300);
    },

    limparBusca() {
      clearTimeout(this.debounceTimeout);
      this.filtroContas = "";
      this.termoBusca = "";
      this.removeSelected();
      this.$nextTick(() => {
        const input = this.$refs.inputBusca;
        if (input && input.$el) {
          input.$el.focus();
        }
      });
    },

    limpar() {
      this.idContaSelecionada = null;
      this.contas = [];
      this.filtroContas = "";
      this.termoBusca = "";
      this.filtroStatus = "ativas";
      this.principaisExpandidos = [];
      this.subcontasExpandidas = [];
      this.listaPronta = false;
    },

    // Exibe a engrenagem de configuração apenas nas contas que o usuário
    // realmente pode configurar — evita mostrar o botão e cair em "Não
    // autorizado". Espelha o backend Usuario::podeConfigurarConta: super-admin
    // (mesmo personificando) acessa qualquer conta; demais administradores,
    // apenas a própria conta ou suas subcontas (exige permissão gerenciar-conta).
    podeConfigurarConta(conta) {
      if (this.checkSuperAdmin) {
        return true;
      }

      if (!this.hasPermission("gerenciar-conta")) {
        return false;
      }

      const minhaContaId = String(this.currentUserPersonalInfo.conta_id);

      return (
        String(conta.id) === minhaContaId ||
        String(conta.contaPrincipalId) === minhaContaId
      );
    },

    // Abre o mesmo modal de Configuração usado na tela de Contas, sem sair da
    // troca de conta. Busca sob demanda apenas os campos de plano que o modal
    // consome direto (Opção A) — os demais dados vêm da própria linha e as
    // abas restantes se auto-carregam por conta.id.
    async abrirConfiguracao(conta) {
      const { data } = await ApiService.get(`conta/dados-plano/${conta.id}`);
      const dadosPlano = data.data;

      this.contaConfig = {
        id: conta.id,
        login: conta.login,
        nome: this.nomeExibicao(conta),
        sigla: conta.sigla,
        contaPrincipal: conta.contaPrincipalId || null,
        tipoPlano: dadosPlano.tipoPlano,
        limiteCredito: dadosPlano.limiteCredito,
        permitirMensagensLongas: dadosPlano.permitirMensagensLongas
      };
      this.exibirAbasConfig = !conta.contaPrincipalId;

      this.$nextTick(() => {
        this.$refs.modalConfiguracao.abrir();
      });
    },

    trocarConta(conta) {
      // Não troca para a conta já ativa (ela aparece na lista apenas como
      // referência/agrupamento das subcontas).
      if (String(conta) === String(this.currentUserPersonalInfo.conta_id)) {
        return;
      }

      Swal.fire({
        title: "Deseja realmente trocar para a conta selecionada?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (!result.value) {
          return;
        }

        // A troca em si é rápida, mas o reload completo da página (+
        // verificar-login) que vem depois tem um instante de tela em branco.
        // Esse overlay preenche o intervalo entre o clique e o reload, para
        // não parecer que a ação travou.
        Swal.fire({
          title: "Trocando de conta...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        ApiService.post("/usuario/trocar-conta", {
          contaId: conta
        })
          .then(() => {
            localStorage.removeItem(
              "filtrosCampanha-" + this.currentUserPersonalInfo.login
            );
            window.location.href = "/";
          })
          .catch(() => {
            Swal.close();
          });
      });
    },

    trocarParaSuperAdmin() {
      Swal.fire({
        title:
          "Deseja realmente trocar o usuário para Administrador do Sistema?",
        showCancelButton: true,
        confirmButtonText: "Trocar",
        cancelButtonText: "Cancelar",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-info"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.get("/usuario/trocar-para-super-admin").then(() => {
            window.location.href = "/";
          });
        }
      });
    },

    obterIdContaSelecionada(obj) {
      this.idContaSelecionada = obj ? obj.id : null;
    },

    obterLinhasNavegaveis() {
      // A lista só monta (ref "lista") depois que listaPronta vira true —
      // ainda vazia no instante inicial de abertura do modal.
      if (!this.$refs.lista) {
        return [];
      }

      return Array.from(this.$refs.lista.querySelectorAll(".linha-navegavel"));
    },

    focusFirstItem() {
      const linhas = this.obterLinhasNavegaveis();
      if (linhas[0]) {
        linhas[0].classList.add("selecionado");
      }
    },

    handleKeyUpDown(event) {
      const linhas = this.obterLinhasNavegaveis();
      const atual = linhas.findIndex((el) =>
        el.classList.contains("selecionado")
      );

      if (atual === -1) {
        this.focusFirstItem();
        return;
      }

      if (event.key === "ArrowDown" && atual < linhas.length - 1) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual + 1].classList.add("selecionado");
      } else if (event.key === "ArrowUp" && atual > 0) {
        linhas[atual].classList.remove("selecionado");
        linhas[atual - 1].classList.add("selecionado");
      }
    },

    changeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );

      if (ativa) {
        this.trocarConta(ativa.getAttribute("data-conta-id"));
      }
    },

    removeSelected() {
      const ativa = this.obterLinhasNavegaveis().find((el) =>
        el.classList.contains("selecionado")
      );
      ativa?.classList.remove("selecionado");
    }
  }
};
</script>

<style lang="scss">
$trocar-conta-purple: #472282;

.trocar-conta-modal-content {
  border: 1px solid #eeecf3;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(31, 20, 60, 0.15);
  overflow: hidden;
}

.trocar-conta-modal-header {
  padding: 1.5rem 1.75rem 0.75rem;

  .modal-title {
    font-weight: 700;
    color: #2b2640;
  }

  .close {
    color: #2b2640;
    text-shadow: none;
    outline: none;

    &:hover {
      color: $trocar-conta-purple;
    }
  }
}

.trocar-conta-modal-header__conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.trocar-conta-modal-header__titulo {
  flex: 1 1 auto;
  margin: 0;
  font-weight: 700;
  color: #2b2640;
}

.trocar-conta-modal-body {
  padding: 0.5rem 1.75rem 1.75rem;
}

.trocar-conta-admin-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  padding: 0.9rem 1.1rem;
  margin-bottom: 1.25rem;
  border: 1px solid #d9cdf0;
  border-radius: 12px;
  background: #f7f4fc;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #ece8f2;
    border-color: $trocar-conta-purple;
  }

  &__icone {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
    color: $trocar-conta-purple;
  }

  &__textos {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__titulo {
    font-weight: 700;
    color: #2b2640;
  }

  &__subtitulo {
    font-size: 0.82rem;
    color: #837f95;
  }
}

.trocar-conta-busca-wrap {
  position: relative;
}

.trocar-conta-busca {
  height: calc(1.5em + 1.3rem + 2px);
  padding: 0.65rem 2.5rem 0.65rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e0ea;

  &:focus {
    border-color: $trocar-conta-purple;
    box-shadow: 0 0 0 0.1rem rgba(71, 34, 130, 0.15);
  }
}

.trocar-conta-busca__limpar {
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #9a95a8;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: #efeef4;
    color: $trocar-conta-purple;
  }
}

.trocar-conta-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.trocar-conta-chip {
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #e2e0ea;
  background: #fff;
  color: #6a6579;
  font-size: 0.82rem;
  font-weight: 600;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: $trocar-conta-purple;
    color: $trocar-conta-purple;
  }

  &--ativo {
    background: $trocar-conta-purple;
    border-color: $trocar-conta-purple;
    color: #fff;

    // .trocar-conta-chip:hover isolado tem a mesma especificidade de
    // .trocar-conta-chip--ativo; sem este seletor mais específico, passar o
    // mouse num chip já ativo reescrevia o texto para roxo escuro sobre o
    // próprio fundo roxo (baixo contraste).
    &:hover {
      background: #3a1b6b;
      border-color: #3a1b6b;
      color: #fff;
    }
  }
}

.trocar-conta-lista-carregando {
  display: flex;
  justify-content: center;
  padding: 2.5rem 0;
}

.trocar-conta-secao-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  color: #2b2640;
  margin: 1.25rem 0 0.6rem;
  font-size: 0.9rem;

  &:first-child {
    margin-top: 0;
  }
}

.trocar-conta-secao-contador {
  font-size: 0.78rem;
  font-weight: 600;
  color: #837f95;
  background: #f4f2f9;
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
}

.trocar-conta-dot {
  font-size: 0.7rem;
  margin-right: 0.35rem;

  &--ativa {
    color: #0e8058;
  }

  &--inativa {
    color: #b42335;
  }

  &--bloqueada {
    color: #946200;
  }

  &--suspensa {
    color: #7e8299;
  }
}

.trocar-conta-card {
  border: 1px solid #eeecf3;
  border-radius: 12px;
  margin-bottom: 0.75rem;
}

.trocar-conta-card__principal > .trocar-conta-card__info {
  border-radius: 12px 0 0 12px;
}

.trocar-conta-card__subcontas {
  border-radius: 0 0 12px 12px;
}

.trocar-conta-card__principal {
  display: flex;
  align-items: stretch;
}

.trocar-conta-card__info {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.85rem 1rem;
  text-align: left;
  background: #fff;
  transition: background-color 0.15s ease;

  &:hover,
  &.selecionado {
    background: #f7f4fc;
  }
}

// Conta atual: fica na lista como referência (agrupa as subcontas), mas não
// é clicável para troca. A cor de fundo (em vez de um badge "Conta atual")
// já indica que essa é a conta selecionada.
.trocar-conta-card__info--atual {
  cursor: default;
  background: #ece8f2;

  &:hover {
    background: #ece8f2;
  }
}

.trocar-conta-avatar {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: $trocar-conta-purple;
  background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
  border: 2px solid #e2d8f5;
}

.trocar-conta-card__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.2rem;
}

.trocar-conta-card__linha1 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.trocar-conta-card__nome {
  font-weight: 700;
  color: #2b2640;
}

.trocar-conta-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
}

.trocar-conta-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.5rem;
  border-radius: 6px;
  background: #f2f1f6;
  color: #514c63;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;

  &--copiavel {
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: #ece8f2;
      color: $trocar-conta-purple;
    }
  }

  &--link {
    text-decoration: none;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: #ece8f2;
      color: $trocar-conta-purple;
      text-decoration: none;
    }
  }
}

.trocar-conta-saldo {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.4rem;
  max-width: 320px;
}

.trocar-conta-saldo__barra {
  height: 8px;
  border-radius: 999px;
  background: #ece8f2;
  overflow: hidden;
}

.trocar-conta-saldo__uso {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #8950fc 0%, #472282 100%);
  transition: width 0.3s ease;
}

.trocar-conta-saldo__texto {
  font-size: 0.74rem;
  color: #6a6579;
  font-weight: 600;
}

.trocar-conta-saldo__alerta {
  color: #d97706;
  margin-left: 0.35rem;
}

.trocar-conta-card__acoes {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding-right: 0.35rem;
}

.trocar-conta-acao-btn {
  flex: 0 0 auto;
  width: 34px;
  border: 0;
  background: transparent;
  color: #837f95;
  font-size: 0.95rem;

  &:hover:not(:disabled) {
    color: $trocar-conta-purple;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  &--sm {
    width: 30px;
    font-size: 0.85rem;
  }
}

.trocar-conta-card__toggle {
  flex: 0 0 auto;
  width: 34px;
  border: 0;
  background: transparent;
  color: #837f95;

  &:hover {
    color: $trocar-conta-purple;
  }
}

.trocar-conta-menu {
  font-size: 0.85rem;

  .dropdown-item {
    padding: 0.5rem 1rem;

    &:active {
      background: $trocar-conta-purple;
    }
  }
}

.trocar-conta-pop__linha {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 0.15rem 0;

  span {
    color: #6a6579;
  }
}

.trocar-conta-card__subcontas {
  border-top: 1px solid #eeecf3;
  background: #fafafc;
  padding: 0.6rem 1rem 0.75rem 3.75rem;
}

.trocar-conta-card__subcontas-cabecalho {
  font-size: 0.78rem;
  font-weight: 700;
  color: #837f95;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.trocar-conta-subconta {
  display: flex;
  align-items: stretch;
  width: 100%;
  border-top: 1px solid #eeecf3;

  &:first-of-type {
    border-top: 0;
  }
}

.trocar-conta-subconta__info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.5rem 0.6rem;
  border-radius: 8px;
  background: transparent;
  text-align: left;

  &:hover,
  &.selecionado {
    background: #f0edf7;
  }
}

.trocar-conta-subconta__acoes {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding-right: 0.25rem;
}

.trocar-conta-subconta__textos {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.trocar-conta-subconta__nome {
  font-size: 0.86rem;
  font-weight: 600;
  color: #2b2640;
}

.trocar-conta-subconta__login {
  font-size: 0.78rem;
}

.trocar-conta-subconta__dados {
  font-size: 0.74rem;
}

.trocar-conta-ver-todas {
  display: inline-block;
  margin-top: 0.4rem;
  padding: 0.3rem 0;
  border: 0;
  background: none;
  color: $trocar-conta-purple;
  font-weight: 600;
  font-size: 0.82rem;

  &:hover {
    text-decoration: underline;
  }
}

.trocar-conta-icone-principal {
  color: #8950fc;
  font-size: 0.7rem;
}
</style>
